import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';



import SettingItem from '../MobileSetting/SettingItem/SettingItem';
import SettingSwitchs from '../MobileSetting/SettingSwitchs/SettingSwitchs';
import SettingModal from '../MobileSetting/SettingModal/SettingModal';


import './Desktop.css';

export default class Desktop extends Component {
  render() {
    const {
      settings,
      switchs,
      social,
      phonenumber,
      email,
      username,
      password,
      password2,
      notif,
      dark,
      openPassword,
      openUsername,
      openEmail,
      openNumber,
      validEmail,
      validPassword,
      validUsername,
      validPhonenumber,
      openModal,
      closeModal,
      changeValue,
      setNotif,
      setDark,
      setOpenSetting
    } = this.props;
    return (
      <div className="setting-box">
        <Fragment>
          <div className="setting__top" onClick={() => setOpenSetting()}></div>
          <div className="setting__right" onClick={() => setOpenSetting()}></div>
          <div className="setting__left" onClick={() => setOpenSetting()}></div>
          <div className="setting__bottom" onClick={() => setOpenSetting()}></div>
          <div className={openNumber || openEmail || openUsername || openPassword ? "phone-number-blur  setting d-flex" : "setting d-flex flex-column"}>
            <div className="setting__right">
              <div className="setting__header d-flex">
                <h1>تنظیمات حساب کاربری</h1>
              </div>
              <div className="setting__fields">
                {
                  settings.map(item => (
                    <SettingItem settings={item} openModal={openModal} key={item.name} />
                  ))
                }
              </div>
            </div>
            <div className="setting__left">
              <div className="setting__switchs d-flex flex-column">
                {
                  switchs.map(item => (
                    <SettingSwitchs switchs={item} key={item.name} setNotif={setNotif} setDark={setDark} name={item.name} />
                  ))
                }
              </div>
              <div className="setting__links">
                <Link to="/privacy"><div>قوانین و مقررات</div></Link>
              </div>
              <div className="setting__save">
                <button>ذخیره تغییرات</button>
              </div>
              <div className="setting__logout">خروج از حساب کاربری</div>
            </div>



            {/* <div className="setting__social d-flex">
              {
                social.map(item => (
                  <a href={item.links} key={item.name}>
                    <img src={item.icon} />
                  </a>
                ))
              }
            </div> */}
          </div>
          {openNumber ? <SettingModal value={phonenumber} valid={validPhonenumber} field={settings[0]} closeModal={closeModal} changeValue={changeValue} /> : null}
          {openEmail ? <SettingModal valid={validEmail} value={email} field={settings[1]} closeModal={closeModal} changeValue={changeValue} /> : null}
          {openUsername ? <SettingModal value={username} valid={validUsername} field={settings[2]} closeModal={closeModal} changeValue={changeValue} /> : null}
          {openPassword ? <SettingModal value={password} value2={password2} valid={validPassword} field={settings[3]} closeModal={closeModal} changeValue={changeValue} /> : null}
        </Fragment >
      </div>
    );
  }
}